import * as React from 'react';
import { TreeItem as MatTreeItem, treeItemClasses, TreeItemProps as MatTreeItemProps } from '@mui/lab';
import { archerConstants } from '../../utils';
import { SxProps, Theme } from '@mui/material';

export type TreeItemProps = MatTreeItemProps;

const styles: Record<string, SxProps<Theme>> = {
  treeItemHover: {
    [`& .${treeItemClasses['label']}:hover`]: {
      backgroundColor: archerConstants.archerHover
    },
    [`& .${treeItemClasses['content']}:hover`]: {
      backgroundColor: 'transparent'
    }
  }
};

const TreeItem: React.FunctionComponent<TreeItemProps> = ({ sx, ...rest }) => (
  <MatTreeItem sx={[styles.treeItemHover, sx] as SxProps<Theme>} {...rest} />
);
TreeItem.displayName = 'TreeItem';
export { TreeItem };
